import React from 'react'
import styled from 'styled-components'

const StyledLoading = styled.div`
  background-color: rgba(255, 255, 255, .8);
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  display: flex;
  cursor: progress;
`

const Spinner = styled.div`
  height: 60px;
  width: 60px;
  margin: auto;
  display: block;
  position: relative;
  -webkit-transition: all 0.3s ease-in-out 0;
  transition: all 0.3s ease-in-out 0;
`

const Chase = styled.div`
  width: 60px;
  height: 60px;
  position: relative;
  animation: sk-chase 2.5s infinite linear both;
`

const Dot = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  animation: sk-chase-dot 2.0s infinite ease-in-out both;

  &:before {
    content: '';
    display: block;
    width: 25%;
    height: 25%;
    background-color: ${props => props.theme.color.face.secondary};
    border-radius: 100%;
    animation: sk-chase-dot-before 2.0s infinite ease-in-out both;
  }

  &:nth-child(1) {
    animation-delay: -1.1s
  }

  &:nth-child(2) {
    animation-delay: -1.0s
  }

  &:nth-child(3) {
    animation-delay: -0.9s
  }

  &:nth-child(4) {
    animation-delay: -0.8s
  }

  &:nth-child(5) {
    animation-delay: -0.7s
  }

  &:nth-child(6) {
    animation-delay: -0.6s
  }

  &:nth-child(1):before {
    animation-delay: -1.1s
  }

  &:nth-child(2):before {
    animation-delay: -1.0s
  }

  &:nth-child(3):before {
    animation-delay: -0.9s
  }

  &:nth-child(4):before {
    animation-delay: -0.8s
  }

  &:nth-child(5):before {
    animation-delay: -0.7s
  }

  &:nth-child(6):before {
    animation-delay: -0.6s
  }

  @keyframes sk-chase {
    100% {
      transform: rotate(360deg)
    }
  }

  @keyframes sk-chase-dot {
    80%,
    100% {
      transform: rotate(360deg)
    }
  }

  @keyframes sk-chase-dot-before {
    50% {
      transform: scale(0.4)
    }

    100%,
    0% {
      transform: scale(1)
    }
  }
`

export const Loading = () => (
  <StyledLoading>
    <Spinner>
      <Chase>
        <Dot />
        <Dot />
        <Dot />
        <Dot />
        <Dot />
        <Dot />
      </Chase>
    </Spinner>
  </StyledLoading>
)

export default Loading